import React from 'react'
import { FormComponent } from '../../../components/form/DynamicForm'
import { Form, Validators } from '../../../components/form/DynamicFormTs'
import { withRouter } from "react-router-dom";
import Http from '../../../Http';

class Transportista extends FormComponent {

  componentDidMount() {
    this.FormConfig(
      { defaultUrl: 'transportista/one', saveUrl: 'transportista/save', backUrl: '/Catalogo/Transportistas' },
      new Form([
        Form.Field('text', 'transportista', 'Clave', '', [Validators.required], 4),
        Form.Field('text', 'transportista_nombre', 'Nombre', '', [Validators.required], 8),
        /* Form.Section('Domicilio'),
        Form.Field('text', 'calle', 'Calle', '', [Validators.required], 6),
        Form.Field('text', 'numero', 'Numero Exterior', '', [Validators.required], 6),
        Form.Field('number', 'codigo_postal', 'Codigo Postal', '', [Validators.required], 6),
        Form.Field('select', 'id_colonia', 'Colonia', '', [Validators.required], 6),
        Form.Field('select', 'ciudad', 'Ciudad', '', [Validators.required], 6),
        Form.Field('select', 'estado', 'Estado', '', [Validators.required], 6), */
      ], ['Guardar'], 'Transportista'), this.formData
    )
    if (this.props.match.params.id)
      this.LoadPreds()
  }

  formData = async (form) => {
    let Res = await Http.get(`cliente/form-generales?${(this.formEstado) ? `e=${this.formEstado}&` : ''}${(this.formCp) ? `cp=${this.formCp}&` : ''}`);
    if (!Res.error) {
      let newForm = Form.FieldOptions(form, 'estado', Res.data.estados, 'id', 'estado');
      if (Res.data.ciudades) newForm = Form.FieldOptions(newForm, 'ciudad', Res.data.ciudades, 'id', 'ciudad');
      if (Res.data.direccion) {
        const { direccion } = Res.data;
        newForm = Form.FieldOptions(newForm, 'chofer_id_colonia', direccion.colonias, 'id', 'colonia');
        newForm = Form.FieldOptions(newForm, 'ciudad', direccion.ciudades, 'id', 'ciudad');
        newForm = Form.Patch(newForm, { estado: direccion.estado.id, ciudad: direccion.ciudad.id });
        newForm = Form.FieldMod(newForm, 'estado', 'Disabled', true);
        newForm = Form.FieldMod(newForm, 'ciudad', 'Disabled', true);
      }
      newForm = Form.ValueChange(newForm, {
        codigo_postal: this.cpChange 
      });
      return newForm;
    }
  }

  cpChange = async (field) => {
    if (field.Value.length === 5) {
      this.formCp = field.Value;
      this.setState({ FormData: await this.formData(this.state.FormData) });
    }
  }

  render() {
    return (
      <div>
        <this.FormRender />
      </div>
    )
  }
}

export default withRouter(Transportista)
